import webClient from "../config/api.config";
import { CareTypePayloadVM } from "../types/care-type.definition";

export function getAllCareTypes(lang = "fr") {
  return webClient.request({
    method: "get",
    url: "/care-types",
    params: { lang },
  });
}

export function getCareTypeTranslations(id: number) {
  return webClient.request({
    method: "get",
    url: `/care-types/${id}/translations`,
  });
}

export function createCareType(data: CareTypePayloadVM) {
  return webClient.request({ method: "post", url: "/care-types", data });
}

export function updateCareType(id: number, data: CareTypePayloadVM) {
  return webClient.request({ method: "put", url: `/care-types/${id}`, data });
}

export function deleteCareType(id: number) {
  return webClient.request({ method: "delete", url: `/care-types/${id}` });
}
